import { Provider, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, NG_VALIDATORS, UntypedFormControl } from '@angular/forms';
import { ValidationResult } from '../validators/validation-result.model';

export abstract class NumberValueAccessor implements ControlValueAccessor {
  public _value: number = 0;

  public isValid = (): boolean => {
    //this function will get overriden in the inherited controls
    //to produce their own logic of valid or not
    return true;
  };
  public validationError: string = '';

  get value(): number {
    return this._value;
  }
  set value(v: number) {
    if (v !== this._value) {
      this._value = v;
      this.onChange(v);
    }
  }
  public constructor() {
    this.validationError = '';
  }
  writeValue(value: number) {
    this._value = value;
    this.onChange(value);
  }

  onBlur() {
    this.onTouched();
  }

  validate = (c: UntypedFormControl): any => {
    if (this.isValid() == false) {
      //return any custom error object if not valid
      let validationResult: ValidationResult = new ValidationResult();
      validationResult.errors.push(this.validationError);
      return validationResult;
    } else {
      //return null if is valid
      return null;
    }
  };

  onChange = (_: any) => {};
  onTouched = () => {};
  registerOnChange(fn: (_: any) => void): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }
}

export function CreateNumberValueAccessorProvider(type: any): any {
  return {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => type),
    multi: true,
  };
}

export function CreateNumberValueValidationProvider(type: any): any {
  return {
    provide: NG_VALIDATORS,
    useExisting: forwardRef(() => type),
    multi: true,
  };
}

//export function CreateNumberValueRequiredValidationProvider() {
//    return new Provider(
//        NG_VALIDATORS, {
//            useValue: (c: FormControl) => {
//                let validationResult: ValidationResult = null;
//                if (c.value <= 0 || c.value == undefined || c.value == null) {

//                    validationResult = new ValidationResult();
//                    validationResult.error = "Number must be >= 0";

//                }

//                return validationResult;
//            },
//            multi: true
//        });
//}
